<template>
  <div class="container">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-row>
        <b-col lg="12">
          <b-card>
            <div slot="header">
              <strong>Policy</strong> <small>Info</small>

            </div>
            <b-row>
              <b-col lg="6">
                <b-form-group>
                  <label for="name">Policy Name for <strong>{{ partnerName }}</strong></label>
                  <b-form-input id="inpPolicyName" type="text" v-model="policy.Name" placeholder="Policy name"></b-form-input>
                </b-form-group>
              </b-col>

              <b-col lg="6">
                <b-alert variant="warning" class="text-center" show><strong>Note: </strong>Rate mark-up does not affect profit type scans.</b-alert>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col lg="12">
          <b-card>
            <div slot="header">
              <strong>Scan</strong> <small>Options</small>
            </div>
            <b-row>
              <b-col lg="4">
                <label>Scan Type</label>
                <b-form-select id="selScanType" :options="[{text:'Profit Scan',value:0},{text:'Selling Price', value:1}]" v-model="policy.ScanType" @change="onScanTypeChange">
                </b-form-select>
              </b-col>
              <b-col lg="3">
                <label v-if="policy.ScanType === 0">
                  Profit Source
                  <b-btn id="profithelper" class="btn btn-info ml-2 rounded-circle text-white">?</b-btn>
                  <b-popover target="profithelper" triggers="hover" placement="top">
                    <template #title>
                      Understanding Profit Source
                    </template>
                    <ul>
                      <li>If the profit source is MSRP, Desired Profit = Desired % of MSRP</li>
                      <li>If the profit source is Cost, Desired Profit = Desired % of Cost</li>
                      <li>If the profit source is a Flat Value, Desired Profit = Desired Value</li>
                    </ul>
                  </b-popover>
                </label>
                <label v-else="policy.ScanType === 0">Selling Price Base</label>

                <b-form-radio-group id="adjustType" v-if="policy.ScanType === 0" v-model="policy.Profit.Type" stacked
                                    :options="[
                      {text: 'MSRP',value: 0},
                      {text: 'Cost',value: 1},
                      {text: 'Flat Dollar Amount',value: 2}
                      ]">
                </b-form-radio-group>
                <b-form-radio-group id="adjustType" v-else v-model="policy.SellingPrice.Type" stacked
                                    :options="[
                    {text: 'Sticker Price',value: 0},
                    {text: 'GSM Price',value: 1},
                    {text: 'Preferred Price',value: 2},
                    {text: 'MSRP',value: 3},
                    {text: 'Cost',value: 4},
                    ]">
                </b-form-radio-group>
              </b-col>
              <b-col lg="5">
                <slot v-if="policy.ScanType === 0">
                  <b-row>
                    <b-col lg="9" v-if="policy.Profit.Type >=2">
                      <label>Desired Amount</label>
                      <b-input-group>
                        <b-input-group-prepend><b-input-group-text><i class="fa fa-dollar"></i>&nbsp; &#177;</b-input-group-text></b-input-group-prepend>
                        <b-form-input name="nAdjustFlatValue" type="text" v-model="policy.Profit.FlatAmount"></b-form-input>
                      </b-input-group>
                    </b-col>
                    <b-col lg="9" v-else>
                      <label>Desired Percent</label>
                      <b-input-group>
                        <b-input-group-prepend><b-input-group-text><i class="fa fa-percent"></i></b-input-group-text></b-input-group-prepend>
                        <b-form-input name="nAdjustPercentage" type="number" v-model="policy.Profit.Value" @change="validateAdjustmentPercentage()"></b-form-input>
                      </b-input-group>
                    </b-col>
                  </b-row>
                </slot>
                <slot v-if="policy.ScanType === 1">
                    <b-form-radio-group v-on:change="isFlatValue=!isFlatValue" v-model="isFlatValue" >
                      <b-form-radio value="true" >
                        <label>Adjustment Dollar Value</label>
                        <b-input-group id="rbFlatValue" >
                          <b-input-group-prepend><b-input-group-text><i class="fa fa-dollar"></i>&nbsp; &#177;</b-input-group-text></b-input-group-prepend>
                          <b-form-input name="nAdjustFlatValue" type="text" v-model="policy.SellingPrice.FlatAmount" :readonly="!isFlatValue" ></b-form-input>
                        </b-input-group>
                      </b-form-radio>
                      <b-form-radio v-if="policy.SellingPrice.Type > 2" value="false" >
                        <label>Adjustment Percent</label>
                        <b-input-group >
                          <b-input-group-prepend><b-input-group-text><i class="fa fa-percent"></i></b-input-group-text></b-input-group-prepend>
                          <b-form-input name="nAdjustPercentage" type="number" v-model="policy.SellingPrice.Value" @change="validateAdjustmentPercentage()" :readonly="isFlatValue" ></b-form-input>
                        </b-input-group>
                      </b-form-radio>
                    </b-form-radio-group>
                </slot>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col >
          <b-card>
            <div slot="header">
              <strong>Vehicle</strong> <small>Rules</small>
              <button id="btnAddNewVehRule" class="btn btn-success" @click="createNewRule()" style="margin-left:10px;"><i title="Add a new vehicle rule" class="fa fa-plus-square"></i></button>
            </div>
            <b-row>
              <b-col lg="12">
                <b-row v-if="!policy.vehiclerules.length" class="b-table-empty-row">
                  <div role="alert" aria-live="polite"><div class="text-center my-2">No rules have been set for this policy yet.</div></div>
                </b-row>
                <b-row v-for="(vr, i) in policy.vehiclerules">
                  <table aria-busy="false" aria-colcount="3" class="table b-table table-striped table-bordered table-sm">
                    <thead class="thead-light">
                      <tr class="d-flex">
                        <th aria-colindex="1" class="col-2">Year</th>
                        <th aria-colindex="2" class="col-2">Make</th>
                        <th aria-colindex="3" class="col-2">Model</th>
                        <th aria-colindex="4" class="col-6">Trim</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="d-flex">
                        <td class="col-2">
                          <b-form-select id="selYear" v-model="vr.year" @change="onRuleYearChanged(vr, $event)" required>
                            <slot v-if="vr.newused === 1">
                              <option v-for="o in policy.list_year_new" :value="o.id">{{ o.name }}</option>
                            </slot>
                            <slot v-else>
                              <option v-for="o in policy.list_year_used" :value="o.id">{{ o.name }}</option>
                            </slot>
                          </b-form-select>
                        </td>
                        <td class="col-2">
                          <b-form-select id="selMake" v-model="vr.make" @change="onRuleMakeChanged(vr, $event)" required>
                            <option v-for="o in vr.make_list" :value="o.id">{{ o.name }}</option>
                          </b-form-select>
                        </td>
                        <td class="col-2">
                          <b-form-select id="selModel" v-model="vr.model" @change="onRuleModelChanged(vr, $event)" required>
                            <option v-for="o in vr.model_list" :value="o.id">{{ o.name }}</option>
                          </b-form-select>
                        </td>
                        <td class="col-6">
                          <b-form-select id="selTrim" v-model="vr.trim" required>
                            <option v-for="o in vr.trim_list" :value="o.id">{{ o.name }}</option>
                          </b-form-select>
                        </td>
                      </tr>
                    </tbody>
                    <thead class="thead-light">
                      <tr class="d-flex">
                        <th aria-colindex="1" class="col-4">Lot Age</th>
                        <th aria-colindex="2" class="col-2">Type</th>
                        <th aria-colindex="3" class="col-6" colspan="2"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="d-flex">
                        <td class="col-4">
                          <div class="d-inline-flex">
                            <b-form-input id="inpLotAgeFrom" type="number" v-model="vr.lotagefrom" placeholder="From" :formatter="nullOnEmpty"
                                          v-validate="{numeric: true, min_value:0, max_value:vr.lotageto}" name="LotAgeFrom"
                                          v-bind:class="{'is-invalid': validateErrors.has('LotAgeFrom') }"></b-form-input>-
                            <b-form-input id="inpLotAgeTo" type="number" v-model.number="vr.lotageto"
                                          placeholder="To" :formatter="nullOnEmpty" min="0" max="9999"
                                          :state="parseInt(vr.lotagefrom) <= parseInt(vr.lotageto)" name="LotAgeTo"
                                          aria-describedby="input-live-help input-live-feedback"
                                          v-validate="{numeric: true, min_value:vr.lotagefrom, max_value:9999}"></b-form-input>
                            <b-form-invalid-feedback id="input-live-feedback" v-if="parseInt(vr.lotagefrom) > parseInt(vr.lotageto)" class="pl-2">
                              To must be greater than From
                            </b-form-invalid-feedback>
                          </div>
                        </td>
                        <td class="col-2">
                          <b-form-select id="selType" :options="[{text:'New',value:1},{text:'Used', value:0}]" v-model="vr.newused" @changed="onRuleVehicleTypeChanged(vr, $event)"></b-form-select>
                        </td>
                        <td class="col-6" colspan="2">
                          <div class="pull-right">
                            <button id="btnDelete" class="btn btn-danger text-white" @click="deleteRule(i)">
                              <i class="fa fa-trash-o fa-lg" title="Delete"></i>
                            </button>
                            <button id="btnCopy" class="btn btn-info text-white" @click="copyToNewRule(vr)">
                              <i class="fa fa-copy fa-lg" title="Copy"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <div slot="footer">
        <div class="d-flex justify-content-between ">
          <button id="btnReturnToPolicies" class="btn btn-warning m-2" @click="closeModal()"><i title="Back" class="fa fa-arrow-left fa-lg text-white"></i> <strong class="text-white">Return to Policies</strong></button>
          <button id="btnSave" class="btn btn-info m-2" @click="saveAndRedirect"><i title="Save" class="fa fa-save fa-lg text-white"></i> <strong class="text-white">Save</strong></button>
          <!--<button id="btnSaveCreateNew" class="btn btn-info m-2" @click="saveAndNew"><i title="Save As" class="fa fa-save fa-lg text-white"></i> <strong class="text-white">Save and Create New</strong></button>-->
        </div>
      </div>
    </div>
    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import loading from 'vue-full-loading'
import { isNullOrUndefined } from 'util'
import { confirm } from 'devextreme/ui/dialog'
export default {
  components: {
    loading
  },
  props:
      ['selPartnerID', 'selPolicyID', 'selPartnerName', 'displayOrder'],

  created () {
    this.errMsg = 'Warning: Do not include rebates within quoting rules. mScanAPI automatically applies appropriate rebates to each payment calculation.'
    this.showDismissibleAlert = true

    if (this.$route.params.policyId !== undefined && this.$route.params.policyId > 0) {
      this.$props.selPolicyID = this.$route.params.policyId
    }

    if (this.$props.selPolicyID === undefined) {
      this.$props.selPolicyID = '-1'
    }

    if (this.$props.selPolicyID == '-1') {
      axios.all([
        axios.get('/api/quotepolicy/getyears?isnew=1&year=0&make=0&model=0'),
        axios.get('/api/quotepolicy/getyears?isnew=0&year=0&make=0&model=0'),
        axios.get('/api/quotepolicy/getmakes?isnew=1&year=&make=0&model=0'),
        axios.get('/api/quotepolicy/getmakes?isnew=0&year=&make=0&model=0')
      ])
        .then(axios.spread((newYearsRes, usedYearsRes, newMakesRes, usedMakesRes) => {
          this.policy.list_year_new = newYearsRes.data
          this.policy.list_year_used = usedYearsRes.data
          this.policy.list_makes_new = newMakesRes.data
          this.policy.list_makes_used = usedMakesRes.data
          this.boolLoading = false
        }))
        .catch(error => {
          if (error.response.status == 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
          this.dismissibleType = 'danger'
        })
      this.policy.DisplayOrder = this.$props.displayOrder
      console.log('partnerID ' + this.$props.selPartnerID)
      if (this.$props.selPartnerID == '0') {
        this.policy.PartnerIDInt = 0
        this.partnerName = 'All Partners'
      } else if (!this.policy.PartnerIDInt) {
        this.policy.PartnerIDInt = this.$props.selPartnerID // window.localStorage.getItem('addquotingpolicy_partneridint')
        this.partnerName = this.$props.selPartnerName // window.localStorage.getItem('addquotingpolicy_partner')
        // window.localStorage.removeItem('addquotingpolicy_partneridint')
        // window.localStorage.removeItem('addquotingpolicy_partner')
      }
      return
    }

    console.log('selPolicyID ' + this.$props.selPolicyID)
    console.log('route.params.policyId ' + this.$route.params.policyId)
    axios.all([
      axios.get('/api/quotepolicy/load?id=' + this.$props.selPolicyID + '&partnerId=' + this.$props.selPartnerID),
      axios.get('/api/quotepolicy/getmakes?isnew=1&year=&make=0&model=0'),
      axios.get('/api/quotepolicy/getmakes?isnew=0&year=&make=0&model=0')
    ])
      .then(axios.spread((policyRes, newMakesRes, usedMakesRes) => {
        this.policy = policyRes.data.data
        this.partnerName = policyRes.data.partner
        this.policy.list_makes_new = newMakesRes.data
        this.policy.list_makes_used = usedMakesRes.data
        if (this.policy.Profit === null) { this.policy.Profit = { Type: 2, Value: 0, FlatAmount: 0 } }
        this.boolLoading = false
      }))
      .catch(error => {
        if (error.response.status == 403) { this.$router.push('/login') }

        this.boolLoading = false
        this.errMsg = 'There was an error getting data : ' + error
        this.showDismissibleAlert = true
        this.dismissibleType = 'danger'
      })
  },
  data () {
    return {
      errMsg: '',
      dismissibleType: 'info',
      showDismissibleAlert: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      isFlatValue: true,
      partnerName: '',
      policy: {
        'ID': -1,
        'PartnerIDInt': 0,
        'Name': '',
        'DisplayOrder': 0,
        'ScanType': 1,
        'SellingPrice': {
          'FlatAmount': 0,
          'Value': 0,
          'Type': 4
        },
        'Profit': {
          'FlatAmount': 0,
          'Value': 0,
          'Type': 2
        },
        'vehiclerules': [],
        'list_year_new': [
          {
            'id': '0',
            'name': 'Any'
          }
        ],
        'list_year_used': [
          {
            'id': '0',
            'name': 'Any'
          }
        ]
      }
    }
  },
  methods: {
    closeModal () {
      this.$emit('clicked', true)
    },
    validateAdjustmentPercentage () {
      // if (this.policy.SellingPrice.Value > 100) {
      //  this.policy.SellingPrice.Value = 100;
      //  this.errMsg = 'Error: Adjustment Percentage must be 0-100.';
      //  this.showDismissibleAlert = true
      //  return false;
      // }
      if (this.policy.ScanType === 1 && this.policy.SellingPrice && this.policy.SellingPrice.Value < 0) {
        this.policy.SellingPrice.Value = 0
        this.errMsg = 'Error: Adjustment Percentage must be greater than or equal to zero.'
        this.showDismissibleAlert = true
        this.dismissibleType = 'danger'
        return false
      }

      return true
    },
    createNewRule () {
      var newRule = {
        id: this.policy.vehiclerules.length ? this.policy.vehiclerules[this.policy.vehiclerules.length - 1].id + 1 : 1,
        newused: 1,
        year: 0,
        make: 0,
        make_list: this.policy.list_makes_new,
        model: 0,
        trim: 0,
        lotagefrom: null,
        lotageto: null,
        model_list: [{ id: '0', name: 'Any' }],
        trim_list: [{ id: '0', name: 'Any' }]
      }
      this.policy.vehiclerules.push(newRule)
    },
    copyToNewRule (rule) {
      var newRule = JSON.parse(JSON.stringify(rule))
      newRule.id = this.policy.vehiclerules[this.policy.vehiclerules.length - 1].id + 1
      this.policy.vehiclerules.push(newRule)
    },
    saveAndNew () {
      this.policy.ID = -1
      if (this.savePolicy()) { this.$router.push('/QuotePolicyDetail/-1') }
    },
    saveAndRedirect () {
      var self = this
      if (this.savePolicy()) {
        self.$emit('clicked', true)
        // this.$router.push('/quotepolicies')
      }
    },

    savePolicy () {
      if (this.isFlatValue && this.policy.SellingPrice != null) { this.policy.SellingPrice.Value = 0 } else if (!this.isFlatValue && this.policy.SellingPrice != null) { this.policy.SellingPrice.FlatAmount = 0 }

      if (!isNullOrUndefined(this.policy.Profit)) {
        if (isNullOrUndefined(this.policy.Profit.Value) || this.policy.Profit.Value === '') {
          this.policy.Profit.Value = 0
        }
        if (isNullOrUndefined(this.policy.Profit.FlatAmount) || this.policy.Profit.FlatAmount === '') {
          this.policy.Profit.FlatAmount = 0
        }
      }

      if (!this.policy.Name || this.policy.Name == '' || !(this.validateAdjustmentPercentage())) {
        this.errMsg = 'Name cannot be blank.'
        this.showDismissibleAlert = true
        this.dismissibleType = 'danger'
        return false
      }

      if (!this.policy.vehiclerules.length) {
        this.errMsg = 'You must add a vehicle rule.'
        this.showDismissibleAlert = true
        this.dismissibleType = 'danger'
        return false
      }

      this.boolLoading = true
      var obj = {}
      obj.data = this.policy
      obj.id = this.policy.ID
      obj.name = this.policy.Name
      obj.displayOrder = this.$props.displayOrder
      obj.partneridint = this.$props.selPartnerID
      obj.err = ''
      obj.replace = false;
      this.$validator.validateAll().then((result) => {
        if (result) {
          axios({
            method: this.policy.ID > 0 ? 'put' : 'post',
            url: '/api/quotepolicy/save',
            data: obj
          })
          .then(response => {
            this.policy.ID = response.data.id
            //  window.history.replaceState({}, null, '/#/QuotePolicyDetail/' + response.data.id)
            if (response.data.err.length > 0) {
              this.errMsg = response.data.err.replaceAll("<br>", "");
              this.dismissibleType = 'danger'
              if (response.data.comfirm == "true") {
                let result = confirm(this.errMsg + "<br>" + response.data.comfirm_msg, 'Confirmation')
                result.then((dialogResult) => {

                  if (dialogResult) {
                    // Save QuotePolicy after
                    obj.replace = true;
                    obj.MSAPIDCQuotePolicyMatches = response.data.MSAPIDCQuotePolicyMatches;
                    this.SaveAndReplacePolicy(obj);

                  } else {
                    
                  }

                  
                });
              }

            } else {
              this.errMsg = 'Quoting rule changes will not be reflected in mDrive search results until the following day.'
              this.dismissibleType = 'success'
              if (this.policy.ID <= 0) {                
                this.$emit('clicked', true)
              }
            }

            this.showDismissibleAlert = true
            this.boolLoading = false 
            return true
          })
          .catch(error => {
            if (error.response.status === 403 && error.response.statusText.indexOf('403.1') === -1) { this.$router.push('/login') }

            console.log(error)
            this.boolLoading = false
            this.errMsg = 'There was an error saving data : ' + error
            this.showDismissibleAlert = true
            this.dismissibleType = 'danger'
            if (error.response.status == 403 && error.response.statusText.indexOf('403.1') !== -1) { this.errMsg = error.response.statusText.replace('403.1', '') }
            return false
          })
        }
        else {
          this.boolLoading = false
          this.errMsg = 'Please fix validation errors'
          this.showDismissibleAlert = true
          this.dismissibleType = 'danger'
        }
      })
    },
    SaveAndReplacePolicy(obj) {
      axios({
        method: this.policy.ID > 0 ? 'put' : 'post',
        url: '/api/quotepolicy/SaveAndReplace',
        data: obj
      }).
      then(response => {
        if (response.data.err.length > 0) {
          this.errMsg = response.data.err
          this.dismissibleType = 'danger'
        } else {
          this.errMsg = 'Quoting rule changes will not be reflected in mDrive search results until the following day.'
          this.dismissibleType = 'success'
          if (this.policy.ID <= 0) {
            this.$emit('clicked', true)
          }
        }
        this.showDismissibleAlert = true
        this.boolLoading = false
        return true
      }).
      catch(error => {
        if (error.response.status === 403 && error.response.statusText.indexOf('403.1') === -1) { this.$router.push('/login') }

        console.log(error)
        this.boolLoading = false
        this.errMsg = 'There was an error saving data : ' + error
        this.showDismissibleAlert = true
        this.dismissibleType = 'danger'
        if (error.response.status == 403 && error.response.statusText.indexOf('403.1') !== -1) {
          this.errMsg = error.response.statusText.replace('403.1', '')
        }
        return false
      })
    },
    onScanTypeChange (value) {
      if (value === 0) {
        if (this.policy.Profit === null) { this.policy.Profit = { Type: 2, Value: 0, FlatAmount: 0 } }
      } else {
        if (this.policy.SellingPrice === null) { this.policy.SellingPrice = { Type: 3, Value: 0, FlatAmount: 0 } }
      }
    },
    onRuleVehicleTypeChanged (rule, arg) {
      if (arg === '1') { rule.make_list = this.policy.list_makes_new } else { rule.make_list = this.policy.list_makes_used }
      rule.year = 0
      rule.make = 0
      rule.model = 0
      rule.trim = 0
    },
    onRuleYearChanged (rule, arg) {
      rule.make = 0
      rule.model = 0
      rule.trim = 0
      this.boolLoading = true
      axios.get('/api/quotepolicy/getmakes?isnew=' + rule.newused + '&year=' + (arg === '0' ? '' : arg) + '&make=' + rule.make + '&model=' + rule.model)
        .then(response => {
          rule.make_list = response.data
          this.boolLoading = false
        })
        .catch(error => {
          if (error.response.status == 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
          this.dismissibleType = 'danger'
        })
    },
    onRuleMakeChanged (rule, arg) {
      rule.model = 0
      rule.trim = 0
      this.boolLoading = true
      axios.get('/api/quotepolicy/getmodels?isnew=' + rule.newused + '&year=' + rule.year + '&make=' + arg + '&model=' + rule.model)
        .then(response => {
          rule.model_list = response.data
          this.boolLoading = false
        })
        .catch(error => {
        })
    },
    onRuleModelChanged (rule, arg) {
      rule.trim = 0
      this.boolLoading = true
      axios.get('/api/quotepolicy/gettrims?isnew=' + rule.newused + '&year=' + rule.year + '&make=' + rule.make + '&model=' + arg)
        .then(response => {
          rule.trim_list = response.data
          this.boolLoading = false
        })
        .catch(error => {
          if (error.response.status == 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
          this.dismissibleType = 'danger'
        })
    },
    deleteRule (ruleIndex) {
      Vue.delete(this.policy.vehiclerules, ruleIndex)
    },
    nullOnEmpty (value, event) {
      if (value === '0') return value

      return value === '' ? null : value
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    if (this.$props.selPolicyID > 0) { this.boolLoading = true }
  }
}
</script>

<style>
  .table-features > tbody > tr > td,
  .table-features > tbody > tr > th {
    border: 0;
    background-color: white;
    padding: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/views/QuotePolicyDetail.vue